import axios from 'axios';

const url = (id, slug) => `/api/v1/wire/${id}/stock_code/${slug}`;

export function add(wireId, scSlug) {
  return axios.post(url(wireId, scSlug));
}

export function remove(wireId, scSlug) {
  return axios.delete(url(wireId, scSlug));
}
